import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { useLanguage } from '../i18n/LanguageContext';
export function WhatIncluded() {
  const {
    t
  } = useLanguage();
  const includes = t.whatIncluded.items;
  return <section className="pt-10 md:pt-14 pb-20 md:pb-28 bg-riam-dark relative overflow-hidden" data-id="element-378">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-riam-gold/5 to-transparent pointer-events-none" data-id="element-379"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-380">
        <div className="max-w-5xl mx-auto" data-id="element-381">
          <SectionHeading title={`${t.whatIncluded.title1}<span class='font-allura font-normal text-5xl md:text-6xl lg:text-7xl align-middle ml-1'>${t.whatIncluded.titleHighlight}</span>${t.whatIncluded.title2}`} subtitle={t.whatIncluded.subtitle} data-id="element-382" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-8 mt-16" data-id="element-383">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start space-x-4" data-id="element-384">
                <div className="mt-1 bg-riam-gold/10 p-1 rounded-full icon-glow" data-id="element-385">
                  <Check size={20} stroke="url(#riamGold)" data-id="element-386" />
                </div>
                <div data-id="element-387">
                  <h4 className="font-script font-semibold text-2xl text-riam-gold mb-1" data-id="element-388">
                    {item.title}
                  </h4>
                  <p className="font-sans font-normal text-riam-gold-light/80" data-id="element-389">
                    {item.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}